import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Wolf from "./assets/wolflogo.png";


import { Link } from 'react-router-dom';
import truncateEthAddress from 'truncate-eth-address';
import { useState, useEffect } from 'react';
import { Box, Image, Stack } from '@chakra-ui/react';
import Opensea from "./assets/social-media-icons/opensea_128x128.png";
import Twitter from "./assets/social-media-icons/twitter_128x128.png";
import Instagram from "./assets/social-media-icons/instagram_128x128.png";
import Discord from "./assets/social-media-icons/discord_128x128.png";

const NavBar = ({ accounts, setAccounts }) => {

    const [connButtonText, setConnButtonText] = useState('Connect');
    const isConnected = Boolean(accounts[0]);

    async function connectAccount() {
        if (window.ethereum) {
            const chainId = await window.ethereum.request({
                method: "eth_chainId",
            });
            if (chainId === '0x89') {
                setAccounts(await window.ethereum.request({
                    method: "eth_requestAccounts",
                }));
                setConnButtonText('CONNECTED');
            } else {
                setConnButtonText('Change to Polygon');
            }
        } else {
            setConnButtonText('Install MetaMask');
        }
    };

    useEffect (() => {
        if (window.ethereum) {
            window.ethereum.on('accountsChanged', function (accounts) {
                window.location.reload();
            })
            window.ethereum.on('chainChanged', function (accounts) {
                window.location.reload();
            })
        }
    });

    return (
        
        <Navbar collapseOnSelect expand="lg" bg="transparent" variant="light">
        <Container fluid>
        <Navbar.Brand href="/"><Image src={Wolf} boxSize={['6.5vw', '5vw', '3.5vw', '2.65vw']} margin="0 15px" /></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav" >
            <Nav className="me-auto" navbarScroll >
            <Nav.Link target="_blank" rel="noopener noreferrer" href="https://twitter.com/WackyWolfFriend">
                <Image src={Twitter} boxSize={['7.5vw', '6vw', '4.5vw', '2.65vw']} margin="0px 8px" />
            </Nav.Link>
 {/*}           <Nav.Link target="_blank" rel="noopener noreferrer" href="https://www.instagram.com">
                <Image src={Instagram} boxSize={['7.5vw', '6vw', '4.5vw', '2.65vw']} margin="0px 8px" />
    </Nav.Link>  */}
            <Nav.Link target="_blank" rel="noopener noreferrer" href="https://discord.gg/c6JKSqYXru">
                <Image src={Discord} boxSize={['7.5vw', '6vw', '4.5vw', '2.65vw']} margin="0px 8px" />
            </Nav.Link>
            <Nav.Link target="_blank" rel="noopener noreferrer" href="https://opensea.io/collection/wacky-wolf-friends">
                <Image src={Opensea} boxSize={['7.5vw', '6vw', '4.5vw', '2.65vw']} margin="0px 8px" />
            </Nav.Link>
{/*
            <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
            </NavDropdown>
*/}
            </Nav>
            <Nav>
                <Stack direction={['column', 'column', 'column', 'row']} align='center'>
                <Box fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}>
                    <Nav.Link as={Link} style={{ textDecoration: 'none', color: 'black', fontWeight: 'bold', align: 'center' }} to={"/"}>Mint</Nav.Link>
                </Box>
                <Box fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}>
                    <Nav.Link as={Link} style={{ textDecoration: 'none', color: 'black', fontWeight: 'bold' }} to={"/rarities"}>Rarities</Nav.Link>
                </Box>
                <Box fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}>
                    <Nav.Link as={Link} style={{ textDecoration: 'none', color: 'black', fontWeight: 'bold' }} to={"/faq"}>FAQ</Nav.Link>
                </Box>

{/*
                <Nav.Link as={Link} style={{ textDecoration: 'none', color: 'black', fontWeight: 'bold', fontSize: '1.75rem'}} to={"/"}>Home</Nav.Link>
                <Nav.Link as={Link} style={{ textDecoration: 'none', color: 'black', fontWeight: 'bold', fontSize: '1.75rem' }} to={"/mint"}>Mint</Nav.Link>
                <Nav.Link as={Link} style={{ textDecoration: 'none', color: 'black', fontWeight: 'bold', fontSize: '1.75rem' }} to={"/roadmap"}>Roadmap</Nav.Link>
                <Nav.Link as={Link} style={{ textDecoration: 'none', color: 'black', fontWeight: 'bold', fontSize: '1.75rem' }} to={"/rarities"}>Rarities</Nav.Link>
                <Nav.Link as={Link} style={{ textDecoration: 'none', color: 'black', fontWeight: 'bold', fontSize: '1.75rem' }} to={"/lore"}>Lore</Nav.Link>
                <Nav.Link as={Link} style={{ textDecoration: 'none', color: 'black', fontWeight: 'bold', fontSize: '1.75rem' }} to={"/faq"}>FAQ</Nav.Link>
*/}
                {/* Connect */}
                {isConnected ? (
                    <Box
                        backgroundColor="#83FFC1"
                        borderRadius="15px"
                        boxShadow="0px 2px 2px 1px #0F0F0F"
                        color="#000000"
                        fontFamily="inherit"
                        fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                        padding="0px 5px"
                        margin="0px 8px"
                        fontWeight="bold"
                        width='auto'
                        >
                        { truncateEthAddress(accounts[0]) }</Box>
                ) : (
                    <Box
                        backgroundColor="red"
                        borderRadius="15px"
                        boxShadow="0px 2px 2px 1px #0F0F0F"
                        color="#000000"
                        cursor="pointer"
                        fontFamily="inherit"
                        fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                        padding="0px 5px"
                        margin="0px 8px"
                        fontWeight="bold"
                        width='auto'
                        align="center"
                        _hover={{
                            background: "white",
                            color: "black",
                          }}

                        onClick={connectAccount}
                    >
                        { connButtonText }
                    </Box>
                )}
                </Stack>
            </Nav>
        </Navbar.Collapse>
        </Container>
        </Navbar>
    );
    };

export default NavBar;